module.exports = __webpack_public_path__ + "img/dnax.b17e70fb.png";